<template>
  <div class="" style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class="d-flex flex-row align-center flex-wrap" style="row-gap: 8px;">
          <h1>WhatsApp {{labelPlural}}</h1>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
              style="margin-left: 10px;"
          ></v-progress-circular>
          <v-spacer></v-spacer>
          <VarionScannerButton
            v-if="isAllowed('booklist','c')"
            class="mr-2"
            target-type="booklistNew"
            label="New via Varion Scanner"
            color="primary"
            @complete="onScannerBooklist"
          />
          <v-btn color="primary" outlined class="mr-2" @click="openScanDialog" v-if="isAllowed('booklist','c')">
            <v-icon left small>mdi-camera</v-icon>Scan from Image(s)
          </v-btn>
          <v-btn color="primary" @click="openCreateDialog" v-if="isAllowed('booklist','c')">
            <v-icon left small>mdi-plus</v-icon>Create {{label}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-tabs v-model="tab">
            <v-tab>{{labelPlural}}</v-tab>
            <v-tab>Orders</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-container fluid>
                <v-row>
                  <v-col cols="3">
                    <v-select
                        label="Status"
                        outlined
                        dense
                        clearable
                        :items="statusOptions"
                        v-model="statusFilter"
                        @change="getBooklists"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-data-table mobile-breakpoint="0"
                        :headers="booklistHeaders"
                        :items="booklists"
                        :items-per-page="15"
                        class="elevation-1"
                        @click:row="rowClick"
                    >
                      <template v-slot:item.status="{ item }">
                        <v-chip small :color="statusColor(item.status)" dark>{{item.status}}</v-chip>
                      </template>
                      <template v-slot:item.requesterPhone="{ item }">
                        {{item.requesterPhone || "—"}}
                      </template>
                      <template v-slot:item.createdAt="{ item }">
                        {{formatDate(item.createdAt)}}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container fluid>
                <v-row>
                  <v-col>
                    <v-data-table mobile-breakpoint="0"
                        :headers="orderHeaders"
                        :items="orders"
                        :items-per-page="15"
                        class="elevation-1"
                    >
                      <template v-slot:item.total="{ item }">
                        ${{Number(item.total).toFixed(2)}}
                      </template>
                      <template v-slot:item.items="{ item }">
                        <span v-for="(line, i) in item.items" :key="i">{{i!==0?", ":""}}{{line.description}} x{{line.qty}}</span>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-select
                            style="max-width: 160px;"
                            dense
                            hide-details
                            :items="orderStatusOptions"
                            :value="item.status"
                            @change="updateOrderStatus(item, $event)"
                        />
                      </template>
                      <template v-slot:item.createdAt="{ item }">
                        {{formatDate(item.createdAt)}}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog scrollable v-model="createDialog" width="700">
      <v-card>
        <v-card-title class="text-h5">Create {{label}}</v-card-title>
        <v-card-text style="padding-top: 20px;">
          <v-row>
            <v-col cols="6">
              <v-text-field label="School" outlined dense v-model="createForm.schoolName"/>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Grade/Class" outlined dense v-model="createForm.grade"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                  label="Search products to add"
                  outlined
                  dense
                  v-model="createSearchTerm"
                  @keydown.enter="searchProducts"
                  append-icon="mdi-magnify"
                  @click:append="searchProducts"
              />
              <v-progress-circular indeterminate color="green" v-if="createSearchLoading"/>
              <v-list dense v-if="createSearchResults.length>0" style="max-height: 200px; overflow-y: auto;" class="elevation-1 mb-4">
                <v-list-item v-for="p in createSearchResults" :key="p.id" @click="addCreateItem(p)">
                  <v-list-item-content>
                    <v-list-item-title style="white-space: normal;">{{p.name}}</v-list-item-title>
                    <v-list-item-subtitle>SKU: {{p.sku || "N/A"}} — ${{Number(p.unitPrice).toFixed(2)}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <v-row v-if="createForm.items.length>0">
            <v-col>
              <v-simple-table dense class="elevation-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th style="width: 15%;">Qty</th>
                      <th style="width: 15%;">Unit Price</th>
                      <th style="width: 15%;">Line Total</th>
                      <th style="width: 8%;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in createForm.items" :key="i">
                      <td>{{item.name}} <span v-if="item.sku" class="grey--text">({{item.sku}})</span></td>
                      <td>
                        <v-text-field dense hide-details type="number" min="1" v-model.number="item.qty"/>
                      </td>
                      <td>${{Number(item.unitPrice).toFixed(2)}}</td>
                      <td>${{(Number(item.unitPrice||0)*Number(item.qty||0)).toFixed(2)}}</td>
                      <td>
                        <v-btn icon small color="error" @click="createForm.items.splice(i,1)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <p class="mt-2 mb-0"><b>Total: ${{createTotal.toFixed(2)}}</b></p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              class="primary"
              text
              @click="createBooklist"
              :loading="creating"
              :disabled="!createForm.schoolName || !createForm.grade || createForm.items.length===0"
          >
            Create
          </v-btn>
          <v-btn class="error" text @click="closeCreateDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="scanDialog" width="560" :persistent="scanning">
      <v-card>
        <v-card-title class="text-h5">Scan {{label}}{{scanIsBulk ? 's' : ''}} from Image</v-card-title>

        <!-- form (hidden once results are in) -->
        <v-card-text v-if="!scanResults" style="padding-top: 20px;">
          <p>Upload one or more photos of a {{label.toLowerCase()}} (printed or handwritten). The items are read automatically and matched against your products.</p>
          <v-file-input
              :label="scanIsBulk ? 'Photos of the lists' : 'Photo of the list'"
              accept="image/*"
              multiple
              outlined
              dense
              prepend-icon="mdi-camera"
              counter
              :show-size="true"
              v-model="scanFiles"
              :disabled="scanning"
          />
          <!-- single upload: allow a manual school/grade override -->
          <template v-if="!scanIsBulk">
            <v-row dense>
              <v-col cols="6">
                <v-text-field label="School (optional)" outlined dense hide-details v-model="scanForm.schoolName" :disabled="scanning"/>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Grade/Class (optional)" outlined dense hide-details v-model="scanForm.grade" :disabled="scanning"/>
              </v-col>
            </v-row>
            <p class="caption grey--text mt-2 mb-0">Leave school and grade blank to detect them from the image automatically.</p>
          </template>
          <!-- bulk upload: dedupe toggle -->
          <template v-else>
            <v-checkbox
                v-model="scanSkipDuplicates"
                :disabled="scanning"
                hide-details
                class="mt-2"
                :label="`Skip suspected duplicates (a ${label.toLowerCase()} with the same school & class already on file)`"
            />
            <p class="caption grey--text mt-2 mb-0">School and class are detected from each image automatically.</p>
          </template>
          <div v-if="scanning" class="mt-4">
            <v-progress-linear indeterminate color="primary"/>
            <p class="caption mt-2 mb-0">
              Reading {{scanIsBulk ? scanFiles.length + ' lists' : 'the list'}} and matching items — this can take
              {{scanIsBulk ? 'a few minutes' : 'up to a minute'}}...
            </p>
          </div>
        </v-card-text>

        <!-- bulk results summary -->
        <v-card-text v-else style="padding-top: 20px;">
          <p class="mb-2">Processed <b>{{scanResults.totalFiles}}</b> image(s):</p>
          <div v-if="scanResults.created.length">
            <p class="success--text mb-1"><b>{{scanResults.created.length}} created</b></p>
            <v-list dense class="py-0">
              <v-list-item v-for="c in scanResults.created" :key="'c'+c.id" @click="$router.push(`/booklists/view/${c.id}`)">
                <v-list-item-content>
                  <v-list-item-title>{{c.schoolName || '(school not detected)'}} — {{c.grade || '(class not detected)'}}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{c.itemCount}} item(s)<span v-if="c.unmatchedCount"> · <span class="orange--text">{{c.unmatchedCount}} unmatched</span></span> · {{c.fileName}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action><v-icon small>mdi-open-in-new</v-icon></v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
          <div v-if="scanResults.duplicates.length" class="mt-3">
            <p class="mb-1"><b>{{scanResults.duplicates.length}} skipped as duplicate(s)</b></p>
            <v-list dense class="py-0">
              <v-list-item v-for="(d,i) in scanResults.duplicates" :key="'d'+i" @click="$router.push(`/booklists/view/${d.existingId}`)">
                <v-list-item-content>
                  <v-list-item-title>{{d.schoolName || '(school not detected)'}} — {{d.grade || '(class not detected)'}}</v-list-item-title>
                  <v-list-item-subtitle>{{d.fileName}} — matches existing #{{d.existingId}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action><v-icon small>mdi-open-in-new</v-icon></v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
          <div v-if="scanResults.errors.length" class="mt-3">
            <p class="error--text mb-1"><b>{{scanResults.errors.length}} could not be read</b></p>
            <v-list dense class="py-0">
              <v-list-item v-for="(e,i) in scanResults.errors" :key="'e'+i">
                <v-list-item-content>
                  <v-list-item-title>{{e.fileName}}</v-list-item-title>
                  <v-list-item-subtitle class="error--text">{{e.reason}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card-text>

        <v-card-actions v-if="!scanResults">
          <v-spacer></v-spacer>
          <v-btn class="primary" text @click="scanBooklist" :loading="scanning" :disabled="!scanFiles.length">
            Scan &amp; Create{{scanIsBulk ? ` (${scanFiles.length})` : ''}}
          </v-btn>
          <v-btn class="error" text @click="scanDialog=false" :disabled="scanning">Cancel</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn class="primary" text @click="closeScanDialog">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from "vuex";
  import VarionScannerButton from './../../components/VarionScannerButton.vue';
  export default {
    components: {
      VarionScannerButton
    },
    data () {
      return {
        loader: true,
        tab: 0,

        snackObj: {
          state: false,
          color: '',
          text: ''
        },

        statusFilter: null,
        statusOptions: ["pending", "approved", "rejected"],
        orderStatusOptions: ["new", "processing", "completed", "cancelled"],

        booklistHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'School', value: 'schoolName' },
          { text: 'Grade', value: 'grade' },
          { text: 'Status', value: 'status' },
          { text: 'Phone', value: 'requesterPhone' },
          { text: 'Requested', value: 'createdAt' },
        ],
        orderHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Phone', value: 'phone' },
          { text: 'Customer', value: 'customerName' },
          { text: 'Items', value: 'items', sortable: false },
          { text: 'Total', value: 'total' },
          { text: 'Source', value: 'source' },
          { text: 'Status', value: 'status' },
          { text: 'Placed', value: 'createdAt' },
        ],

        booklists: [],
        orders: [],

        scanDialog: false,
        scanning: false,
        scanFiles: [],
        scanSkipDuplicates: true,
        scanResults: null,
        scanForm: {
          schoolName: "",
          grade: ""
        },

        createDialog: false,
        creating: false,
        createSearchTerm: "",
        createSearchResults: [],
        createSearchLoading: false,
        createForm: {
          schoolName: "",
          grade: "",
          items: []
        }
      }
    },
    async mounted(){
      await Promise.all([this.getBooklists(), this.getOrders()]);
      this.loader = false;
    },
    computed: {
      ...mapGetters(['getEndpoint', 'getGlobalValue', 'isAllowed']),
      label(){
        return this.getGlobalValue('VEC_BOOKLIST_LABEL') || "Booklist";
      },
      labelPlural(){
        return `${this.label}s`;
      },
      createTotal(){
        return this.createForm.items.reduce((acc,x)=>acc+(Number(x.unitPrice||0)*Number(x.qty||0)),0);
      },
      scanIsBulk(){
        return this.scanFiles.length > 1;
      }
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      // A booklist was captured from a phone via the Varion Scanner. Refresh the list and, if we
      // know the new record's id, jump straight to it.
      onScannerBooklist(payload){
        this.getBooklists();
        if(payload && payload.booklistId){
          this.snack("Booklist created from scanner.", "success");
          this.$router.push({ path: `/booklists/view/${payload.booklistId}` });
        }
      },
      formatDate(d){
        return d ? new Date(d).toLocaleString() : "";
      },
      statusColor(status){
        if(status==="approved") return "success";
        if(status==="rejected") return "error";
        return "orange";
      },
      rowClick(row){
        this.$router.push({ path: `/booklists/view/${row.id}`})
      },
      async getBooklists(){
        try {
          let query = this.statusFilter ? `?status=${this.statusFilter}` : "";
          let res = await axios.get(`${this.getEndpoint}/api/whatsapp/booklists${query}`)
          if(res.data.error) throw res.data.error

          this.booklists = res.data.data
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
      },
      async getOrders(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/whatsapp/orders`)
          if(res.data.error) throw res.data.error

          this.orders = res.data.data
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
      },
      async updateOrderStatus(order, status){
        try {
          let res = await axios.put(`${this.getEndpoint}/api/whatsapp/orders/${order.id}/status`, {status})
          if(res.data.error) throw res.data.error

          order.status = status;
          this.snack(`Order #${order.id} marked as ${status} 🎉`, "success");
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
          await this.getOrders();
        }
      },
      openScanDialog(){
        this.scanFiles = [];
        this.scanSkipDuplicates = true;
        this.scanResults = null;
        this.scanForm = {schoolName: "", grade: ""};
        this.scanDialog = true;
      },
      closeScanDialog(){
        this.scanDialog = false;
        // refresh the table so newly created booklists show up
        if(this.scanResults && this.scanResults.created.length) this.getBooklists();
      },
      async scanBooklist(){
        if(!this.scanFiles.length) return;
        this.scanIsBulk ? await this.bulkScan() : await this.singleScan();
      },
      async singleScan(){
        try {
          this.scanning = true;
          let fd = new FormData();
          fd.append("image", this.scanFiles[0]);
          if(this.scanForm.schoolName) fd.append("schoolName", this.scanForm.schoolName);
          if(this.scanForm.grade) fd.append("grade", this.scanForm.grade);

          let res = await axios.post(`${this.getEndpoint}/api/whatsapp/booklists/fromImage`, fd, {headers: {"Content-Type": "multipart/form-data"}})
          if(res.data.error) throw res.data.error

          let created = res.data.data;
          let unmatched = (created.items || []).filter(x => !x.matched).length;
          this.snack(unmatched > 0
            ? `${this.label} created — ${unmatched} item(s) need your attention 👀`
            : `${this.label} created and all items matched 🎉`, "success");
          this.scanDialog = false;
          this.$router.push({ path: `/booklists/view/${created.id}`})
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.scanning = false;
        }
      },
      async bulkScan(){
        try {
          this.scanning = true;
          let fd = new FormData();
          for(let f of this.scanFiles) fd.append("images", f);
          fd.append("skipDuplicates", this.scanSkipDuplicates ? "true" : "false");

          let res = await axios.post(`${this.getEndpoint}/api/whatsapp/booklists/bulkFromImage`, fd, {headers: {"Content-Type": "multipart/form-data"}})
          if(res.data.error) throw res.data.error

          this.scanResults = res.data.data; // switches the dialog to the results view
          let {created, duplicates, errors} = this.scanResults;
          this.snack(`${created.length} created, ${duplicates.length} skipped, ${errors.length} failed`,
            errors.length ? "warning" : "success");
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.scanning = false;
        }
      },
      openCreateDialog(){
        this.createForm = {schoolName: "", grade: "", items: []};
        this.createSearchTerm = "";
        this.createSearchResults = [];
        this.createDialog = true;
      },
      closeCreateDialog(){
        this.createDialog = false;
      },
      async searchProducts(){
        if(!this.createSearchTerm) return;
        try {
          this.createSearchLoading = true;
          let res = await axios.get(`${this.getEndpoint}/api/whatsapp/productSearch`, {params: {val: this.createSearchTerm}})
          if(res.data.error) throw res.data.error

          this.createSearchResults = res.data.data
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.createSearchLoading = false;
        }
      },
      addCreateItem(product){
        let existing = this.createForm.items.find(x => x.productId===product.id);
        if(existing){
          existing.qty++;
          return;
        }
        this.createForm.items.push({
          productId: product.id,
          name: product.name,
          sku: product.sku,
          unitPrice: Number(product.unitPrice),
          qty: 1
        });
      },
      async createBooklist(){
        try {
          this.creating = true;
          let res = await axios.post(`${this.getEndpoint}/api/whatsapp/booklists`, {
            schoolName: this.createForm.schoolName,
            grade: this.createForm.grade,
            items: this.createForm.items.map(x => ({productId: x.productId, qty: x.qty}))
          })
          if(res.data.error) throw res.data.error

          this.snack(`${this.label} created 🎉`, "success");
          this.closeCreateDialog();
          await this.getBooklists();
          this.$router.push({ path: `/booklists/view/${res.data.data.id}`})
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.creating = false;
        }
      }
    }
  }
</script>
